import { IconCreditCard } from '@vtex/admin-ui'
import { useWatch } from '@vtex/admin-ui-form'
import { useIntl } from 'react-intl'
import type { BIN as BINType } from 'typings'
import { useFormStateContext } from '../../../../providers'
import { useDrawerState } from '../../../Drawer'
import { useConditions } from '../useConditions'
import { BINEditor } from './BINEditor'
import { BINView } from './BINView'
import { messages } from './messages'

interface Props {
  name: string
}

export function BIN(props: Props) {
  const { name } = props

  const { formatMessage: i18n } = useIntl()
  const drawerState = useDrawerState()
  const { form } = useFormStateContext()

  const config: BINType | undefined = useWatch({ form, name })

  const handleSave = (codes: BINType) => {
    form.setValue(name, codes.length ? codes : undefined)
  }

  const handleRemove = () => {
    form.setValue(name, undefined)
  }

  useConditions({
    name,
    onEdit: drawerState.show,
    label: i18n(messages.title),
    icon: <IconCreditCard />,
  })

  return (
    <>
      <BINEditor state={drawerState} config={config} onSave={handleSave} />
      <BINView
        onEdit={drawerState.show}
        onRemove={handleRemove}
        values={config}
      />
    </>
  )
}
